import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { useState } from 'react';
import useImageLoaded from '../hooks/useImageLoaded';
import ContentCard from './ContentCard';
import Spinner from './Spinner';
const ImageTownCard = ({ link, src, alt, onClose, children, }) => {
    // Handle image visibility
    const { ref, state } = useImageLoaded();
    const imgClasses = classNames('relative aspect-3/2 object-cover object-center w-full h-full transition-opacity duration-500 laptop:aspect-2/3', state === 'loaded' ? 'opacity-100' : 'opacity-0');
    // Handle spinner visibility
    const [showSpinner, setShowSpinner] = useState(state === 'loading');
    const handleTransitionEnd = () => {
        if (showSpinner && state === 'loaded')
            setShowSpinner(false);
    };
    return (_jsx(ContentCard, { onClose: onClose, closeClasses: "bg-white shadow top-4 right-4 tablet-portrait:shadow-none laptop:shadow", children: _jsxs("a", { href: link, className: "group", role: "link", children: [_jsx("div", { className: "absolute inset-x-0 bottom-0 z-10 pointer-events-none opacity-60 bg-gradient-to-t from-black h-1/2 transition-all duration-200 group-hover:opacity-90" }), _jsxs("div", { className: "relative", children: [_jsxs("div", { className: "bg-grey-50", children: [showSpinner && (_jsx("div", { className: "absolute inset-0 flex items-center justify-center", children: _jsx(Spinner, {}) })), _jsx("img", { ref: ref, src: src, alt: alt, className: imgClasses, onTransitionEnd: handleTransitionEnd })] }), children] })] }) }));
};
export default ImageTownCard;
